module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "max-width": "1000px",
      "fullscreen": _vm.$vuetify.breakpoint.xsOnly
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', {
    staticClass: "ims-modal-card safe-zone-preview-card"
  }, [_c('v-toolbar', {
    staticClass: "ims-modal-header",
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-toolbar-title', {
    staticClass: "font-weight-bold"
  }, [_vm._v("Preview of safe zones")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-container', {
    staticClass: "ims-modal-body safe-zone-preview-body",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-row', {
    staticClass: "safe-zone-preview-options"
  }, [_c('v-col', {
    staticClass: "pa-0 d-flex flex-wrap justify-center",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-switch', {
    staticClass: "mr-5",
    attrs: {
      "label": "Preview IG Reel"
    },
    on: {
      "change": function($event) {
        return _vm.changeCutOff('IG')
      }
    },
    model: {
      value: (_vm.isIGCutOff),
      callback: function($$v) {
        _vm.isIGCutOff = $$v
      },
      expression: "isIGCutOff"
    }
  }), _vm._v(" "), _c('v-switch', {
    staticClass: "mr-5",
    attrs: {
      "label": "Preview IG Story"
    },
    on: {
      "change": function($event) {
        return _vm.changeCutOff('IGStory')
      }
    },
    model: {
      value: (_vm.isIGStory),
      callback: function($$v) {
        _vm.isIGStory = $$v
      },
      expression: "isIGStory"
    }
  }), _vm._v(" "), _c('v-switch', {
    attrs: {
      "label": "Preview Tiktok"
    },
    on: {
      "change": function($event) {
        return _vm.changeCutOff('tiktok')
      }
    },
    model: {
      value: (_vm.isTikTokCutOff),
      callback: function($$v) {
        _vm.isTikTokCutOff = $$v
      },
      expression: "isTikTokCutOff"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "safe-zone-preview-media"
  }, _vm._l((_vm.postData.media), function(media, index) {
    return _c('v-col', {
      key: index,
      attrs: {
        "cols": "12",
        "sm": "6",
        "md": "4"
      }
    }, [_c('custom-media-v2', {
      attrs: {
        "media": _vm.campaignHelper.customPostMediaConfig(media, {
          overlay: true,
          overlayType: _vm.overlayType,
          creatorView: true,
          postView: true
        })
      }
    }), _vm._v(" "), (!media.preview.thumbnail) ? _c('btn-download', {
      attrs: {
        "url": media.preview.src
      }
    }) : _vm._e()], 1)
  }), 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "ims-modal-actions safe-zone-preview-actions"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "depressed": ""
    },
    on: {
      "click": _vm.confirm
    }
  }, [_vm._v("OK")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-63b31dbd"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Post/PostMediaPreviewModal.vue
// module id = 2158
// module chunks = 0